import React, { useState } from 'react';
import { useMatch } from '../context/MatchContext';
import ATC_TECHNIQUES from '../utils/atcTechniques';

const ACTION_TYPES = [
  { id: 'a',  label: 'Attacco',               abbr: 'A' },
  { id: 'd',  label: 'Difesa',                abbr: 'D' },
  { id: 'c',  label: 'Contrattacco',          abbr: 'C' },
  { id: 'ca', label: 'Contro anticipo',       abbr: 'Ca' },
  { id: 'ci', label: 'Contro incastro',       abbr: 'Ci' },
  { id: 'c2', label: 'Contro 2° tempo',       abbr: 'C2' },
];

function ActionPanel() {
  const { state, setActionField } = useMatch();
  const { currentAction } = state;
  const [customName, setCustomName] = useState('');

  const handleTechniqueSelect = (techId) => {
    setActionField('technique', techId);
    if (techId !== 'custom') setActionField('customTechnique', '');
  };

  const handleCustomName = (val) => {
    setCustomName(val);
    setActionField('customTechnique', val);
  };

  return (
    <div className="panel">
      <div className="panel-header">Azione</div>
      <div className="panel-body">

        {/* Tipo azione */}
        <div className="panel-section">
          <span className="panel-label">Tipo</span>
          <div className="action-type-grid">
            {ACTION_TYPES.map(at => (
              <button
                key={at.id}
                className={`action-type-btn${currentAction.actionType === at.id ? ' selected' : ''}`}
                onClick={() => setActionField('actionType', at.id)}
              >
                <span className="action-type-abbr">{at.abbr}</span>
                <span style={{ fontSize: 11 }}>{at.label}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="separator" />

        {/* Tecniche */}
        <div className="panel-section">
          <span className="panel-label">Tecnica</span>
          <div className="technique-grid">
            {ATC_TECHNIQUES.map(tech => (
              <button
                key={tech.id}
                className={`technique-btn${currentAction.technique === tech.id ? ' selected' : ''}`}
                onClick={() => handleTechniqueSelect(tech.id)}
                title={tech.name}
              >
                <span className="technique-abbr">{tech.id}</span>
                <span className="technique-name">{tech.name}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Custom input */}
        {currentAction.technique === 'custom' && (
          <div className="panel-section">
            <span className="panel-label">Nome tecnica custom</span>
            <input
              className="url-input"
              placeholder="Es. Twio Neryo..."
              value={customName}
              onChange={e => handleCustomName(e.target.value)}
            />
          </div>
        )}

      </div>
    </div>
  );
}

export default ActionPanel;
